import {Language} from '@dms/api/sales';

const LANGUAGES = ['cs', 'en', 'de', 'es', 'fr', 'nl', 'it', 'pl', 'sk'] as const;

// Compile-time exhaustiveness: if the Language union changes without updating
// LANGUAGES above, this literal will fail to type-check (missing or extra keys).
const _exhaustive: Record<Language, true> = {
  cs: true,
  en: true,
  de: true,
  es: true,
  fr: true,
  nl: true,
  it: true,
  pl: true,
  sk: true,
};
void _exhaustive;

const LANGUAGE_SET: ReadonlySet<string> = new Set<Language>(LANGUAGES);

export class UnsupportedLanguageError extends Error {
  constructor(value: string) {
    super(`Unsupported language code: "${value}"`);
    this.name = 'UnsupportedLanguageError';
  }
}

export function isSupportedLanguage(value: string): value is Language {
  return LANGUAGE_SET.has(value);
}

export function toLanguage(value: string): Language {
  if (!isSupportedLanguage(value)) {
    throw new UnsupportedLanguageError(value);
  }
  return value;
}
